import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  constructor(private http: HttpClient) { }


  getClients(perPage: number, page: number, warehouseId: number): Observable<any> {
    return this.http.get(`${environment.Server_URL}/clients`, {
      params: {
        per_page: perPage.toString(),
        page: page.toString(),
        warehouse_id: warehouseId.toString()
      }
    });
  }
  createClient(data: any) {
    return this.http.post(`${environment.Server_URL}/clients`, data);
  }

  getClientsUserLvl(perpage: any, page: any, userId: any): Observable<any> {
    const body = new FormData();
    body.append('per_page', perpage);
    body.append('user_id', userId);
    return this.http.post(`${environment.Server_URL}/clients/users?page=${page}`, body);
  }
  delete(id: string): Observable<any> {
    return this.http.delete(environment.Server_URL + '/delete/stock/' + id);
  }

  searchClients(phone?: string, warehouseId?: number, userId?: number) {
    const body = new FormData();

    if (phone) body.append('phone', phone);
    if (warehouseId) body.append('warehouse_id', warehouseId.toString());
    if (userId) body.append('user_id', userId.toString());

    return this.http.post(
      `${environment.Server_URL}/search-clients`,
      body
    );
  }


}
